import { render, staticRenderFns } from "./MailInfo.vue?vue&type=template&id=57ca5c53&scoped=true"
import script from "./MailInfo.vue?vue&type=script&lang=js"
export * from "./MailInfo.vue?vue&type=script&lang=js"
import style0 from "./MailInfo.vue?vue&type=style&index=0&id=57ca5c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ca5c53",
  null
  
)

export default component.exports